// extracted by mini-css-extract-plugin
export var audioPlayer = "_nz-0";